export const PRICING_OPTIONS = [
  { key: 'free', label: 'Free' },
  { key: 'freemium', label: 'Freemium' },
  { key: 'ios-free', label: 'Free iOS' },
  { key: 'ios-paid', label: 'Paid iOS' },
  { key: 'subscription', label: 'Subscription' },
  { key: 'one-time', label: 'One time' },
  { key: 'trial', label: 'Trial' },
];

export const PLATFORMS_OPTIONS = [
  { key: 'browser-extension', label: 'Browser extension' },
  { key: 'ios', label: 'iOS' },
  { key: 'android', label: 'Android' },
  { key: 'windows', label: 'Windows' },
  { key: 'mac', label: 'Mac' },
];

export const SOCIALS_OPTIONS = [
  { key: 'twitter', label: 'Twitter' },
  { key: 'discord', label: 'Discord' },
];

export const OTHER_OPTIONS = [
  { key: 'open-source', label: 'Open Source' },
  { key: 'ai', label: 'AI powered' },
];
